module.exports = __webpack_public_path__ + "img/icon_selected.21b57eea.svg";